import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-377debe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Projeto de expansão", -1))
const _hoisted_5 = { class: "card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-muted me-8" }, "Vendedores", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0 text-end"
}, " Mês ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}, " Custo R$ ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}, " Vendas ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}, " Vendas Acumulada ", -1))
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0 text-end"
}, " Luco Acumulado R$ ", -1))
const _hoisted_16 = { class: "shadow-none lh-1 fw-bold ps-0 text-end" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-end text-black" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-end text-black" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-end" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_24 = { class: "fw-medium text-end text-black" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_30 = { class: "fw-medium text-end text-danger fw-bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_36 = { class: "fw-medium text-end text-primary fw-bold" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_42 = { class: "fw-medium text-end text-black fw-bold" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_48 = { class: "fw-medium text-end text-primary fw-bold" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_54 = { class: "fw-medium text-end text-primary" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_60 = { class: "fw-medium text-end text-danger" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_66 = { class: "fw-medium text-end text-info fw-bold" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_72 = { class: "fw-medium text-end text-info fw-bold" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_78 = { class: "fw-medium text-end text-info fw-bold" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_84 = { class: "fw-medium text-end text-info fw-bold" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_90 = { class: "fw-medium text-end text-info fw-bold" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))

import { onMounted, reactive } from "vue";
  import meses from "./meses.json";
  import {f2dec} from "@/utils/funcoes";

  interface Item {
    mes: number,
    vlrCusto: number,
    qtdeVendas: number,
    qtdeAcum: number,
    vlrLucroMes: number,
    vendasAcum: number,
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


  var controle = reactive({
    qtdeVendedores: 1,
    percLucro: 11,
    vlrPlano: 80,
    itens: [] as Item[],

    qtdeAcum: 0,
    vendasAcum: 0,
    lucroAcum:0,
  })

  onMounted(()=> {
    
    calcularValores();
  })

 function calcularValores() {
    controle.itens = [];

    controle.qtdeAcum = 0;
    controle.vendasAcum = 0;
    controle.lucroAcum = 0;

    meses.forEach(a=> {

      controle.qtdeAcum += parseInt(a.qtdeVendas) * controle.qtdeVendedores;

      var item = {}as Item;
      
      item.mes = parseInt(a.mes);
      item.vlrCusto = controle.qtdeVendedores * parseFloat(a.custo);
      item.qtdeVendas = controle.qtdeVendedores * parseInt(a.qtdeVendas);
      item.qtdeAcum =  controle.qtdeAcum;
      var vendasMes = (((item.qtdeAcum * controle.vlrPlano) ) ) * (controle.percLucro / 100)
      item.vlrLucroMes = ( ( item.qtdeAcum) * controle.vlrPlano) * (controle.percLucro / 100);
      
      controle.vendasAcum += item.vlrLucroMes;
      item.vendasAcum = controle.vendasAcum;

      

      controle.itens.push(item);
    })
 }


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).qtdeVendedores) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (calcularValores())),
            class: "form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
              return _createElementVNode("option", {
                value: n,
                class: "fw-medium",
                key: n
              }, _toDisplayString(n), 9, _hoisted_7)
            }), 64))
          ], 544), [
            [_vModelSelect, _unref(controle).qtdeVendedores]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("th", _hoisted_14, " Lucro " + _toDisplayString(_unref(f2dec)(_unref(controle).percLucro)) + "% ", 1),
              _hoisted_15
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      to: "/product-details",
                      class: "text-decoration-none text-black"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.mes), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-semibold text-end", item.vlrCusto > 0? 'text-danger' : 'text-black'])
                  }, " R$ " + _toDisplayString(_unref(f2dec)(item.vlrCusto)), 3),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(item.qtdeVendas), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(item.qtdeAcum), 1),
                  _createElementVNode("td", _hoisted_19, [
                    _createTextVNode(" R$ " + _toDisplayString(_unref(f2dec)(item.vlrLucroMes)) + " ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(['badge', item.class])
                    }, _toDisplayString(item.status), 3)
                  ]),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 text-end pe-0", item.vendasAcum > _unref(controle).itens[0].vlrCusto ? 'text-blue fw-bold' : 'text-danger'])
                  }, " R$ " + _toDisplayString(_unref(f2dec)(item.vendasAcum)), 3)
                ]),
                (idx == 11)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", null, [
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        _createElementVNode("td", _hoisted_24, " R$ " + _toDisplayString(_unref(f2dec)(19008)), 1),
                        _hoisted_25
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28,
                        _hoisted_29,
                        _createElementVNode("td", _hoisted_30, " R$ " + _toDisplayString(_unref(f2dec)(-3000)), 1),
                        _hoisted_31
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_32,
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _createElementVNode("td", _hoisted_36, " R$ " + _toDisplayString(_unref(f2dec)(16008)), 1),
                        _hoisted_37
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_38,
                        _hoisted_39,
                        _hoisted_40,
                        _hoisted_41,
                        _createElementVNode("td", _hoisted_42, " MÉDIA ANO " + _toDisplayString(_unref(f2dec)(1.8)) + " % ", 1),
                        _hoisted_43
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_44,
                        _hoisted_45,
                        _hoisted_46,
                        _hoisted_47,
                        _createElementVNode("td", _hoisted_48, " ACUMULADO ANO " + _toDisplayString(_unref(f2dec)(21.6)) + " % ", 1),
                        _hoisted_49
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("tr", null, [
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53,
              _createElementVNode("td", _hoisted_54, " R$ " + _toDisplayString(_unref(f2dec)(63888)), 1),
              _hoisted_55
            ]),
            _createElementVNode("tr", null, [
              _hoisted_56,
              _hoisted_57,
              _hoisted_58,
              _hoisted_59,
              _createElementVNode("td", _hoisted_60, " R$ " + _toDisplayString(_unref(f2dec)(-6000)), 1),
              _hoisted_61
            ]),
            _createElementVNode("tr", null, [
              _hoisted_62,
              _hoisted_63,
              _hoisted_64,
              _hoisted_65,
              _createElementVNode("td", _hoisted_66, " R$ " + _toDisplayString(_unref(f2dec)(57888)), 1),
              _hoisted_67
            ]),
            _createElementVNode("tr", null, [
              _hoisted_68,
              _hoisted_69,
              _hoisted_70,
              _hoisted_71,
              _createElementVNode("td", _hoisted_72, " MEDIA DO ANO " + _toDisplayString(_unref(f2dec)(6.41)) + " % MES ", 1),
              _hoisted_73
            ]),
            _createElementVNode("tr", null, [
              _hoisted_74,
              _hoisted_75,
              _hoisted_76,
              _hoisted_77,
              _createElementVNode("td", _hoisted_78, " ACUMULADO ANO " + _toDisplayString(_unref(f2dec)(77)) + " % ", 1),
              _hoisted_79
            ]),
            _createElementVNode("tr", null, [
              _hoisted_80,
              _hoisted_81,
              _hoisted_82,
              _hoisted_83,
              _createElementVNode("td", _hoisted_84, " A PARTIR DO 25º MES " + _toDisplayString(_unref(f2dec)(9.6)) + " % MES ", 1),
              _hoisted_85
            ]),
            _createElementVNode("tr", null, [
              _hoisted_86,
              _hoisted_87,
              _hoisted_88,
              _hoisted_89,
              _createElementVNode("td", _hoisted_90, " MEDIA ANUAL " + _toDisplayString(_unref(f2dec)(115.20)), 1),
              _hoisted_91
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})